module.exports = __webpack_public_path__ + "static/media/logo.ee7cd8ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 97
// module chunks = 0